export enum MenuLinkEnum
{
    HomeRoot = 1,
    OpsTowerRoot = 2,
    RegistrationOnboarding = 3,
    Passenger2W = 4,
    Passenger3W = 5,
    Passenger4W = 6,
    Delivery2W = 7,
    Delivery4W = 777,
    Vehicles = 8,
    OperatorsVehicles = 9,
    OperatorsTODAs = 10,
    TransactionsCustomer = 11,
    TransactionsDrivers = 12,
    Eats = 13,
    Mart = 14,
    NewCases = 15,
    InProcess = 16,
    Archived = 17,
    XpressLocations = 18,
    Calendar = 19,
    Users = 20,
    Suspended = 21,
    Blacklisted = 22,
    LGU = 23,
    MarketingDashboard = 24,
    MarketingOffline = 25,
    MarketingEvents = 26,
    MarketingPromotions = 27,
    MarketingAdvertisements = 28,
    Integrations = 29,
    BroadcastMessage = 30,
    CommsFeedbacks = 31,
    Report = 32,
    FinancesDashboard = 33,
    Revenue = 34,
    Inventory = 35,
    Accounting = 36,
    Settings = 37,
    AllUsers = 38,
    Roles = 39,
    AppAudit = 40,

    BoracayVehicles = 41,
    Campaign3W = 42,
    Campaign4W = 43,
    Owners = 44,

    CampaignUsers = 45,

    RegionMapEditor = 46,

    OperatorDashboard = 47,
    OperatorReports = 48,
    OperatorFinance = 49,

    PartnerDashboard = 50,
    PartnerEmployees = 51,
    PartnerCatalogue = 52,
    PartnerInventory = 53,
    PartnerFinance = 54,
    PartnerAppConfig = 55,
    Orders = 56,
    Locations = 57,
    Marketing = 58,
    Insights = 59,
    AllOrders = 60,
    Feedback = 61,

    PartnerDashboardSwitch = 62,
    Commerce = 63
}
